export enum PaymentMethodTypeEnum {
  ACH = 'ACH',
  CreditCard = 'Credit Card',
  Check = 'Check'
}
